import { render } from "./HomeView.vue?vue&type=template&id=0dcb3d09&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=0dcb3d09&scoped=true&lang=css"

import exportComponent from "/home/forge/obs.etr.audio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dcb3d09"]])

export default __exports__